export default "__VITE_ASSET__vQ4XRVUa__"